// Gallery-context action sheet. Shows rename / download / move /
// delete — the actions that make sense when *viewing* a single
// file. No Preview (gallery IS preview) and no Copy chunk ID
// (debug-only affordance, kept on the browser's context menu).

import { ItemActionSheet } from "@/components/browser/ItemActionSheet";

interface Props {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  fileName: string;
  onExport: () => void;
  onRename: () => void;
  onMove: () => void;
  onDelete: () => void;
}

export function GalleryActionSheet({
  open,
  onOpenChange,
  fileName,
  onExport,
  onRename,
  onMove,
  onDelete,
}: Props) {
  return (
    <ItemActionSheet
      open={open}
      onOpenChange={onOpenChange}
      title={fileName}
      single
      onExport={onExport}
      onRename={onRename}
      onMove={onMove}
      onDelete={onDelete}
    />
  );
}
